
<template>
  <section>
    <div class="area_pantalla">
    <div class="scroll_vertical">
    <div style="height: 22%"></div>

      <center>
        <div style="width: 77%; max-width: 400px">
          <img style="width: 80%; max-width: 300px" src="@/assets/logo_rackon2.svg" />

          <v-container>
             <br/>
              <span class="mt-10 text-h7" :class="es_error ? 'red--text text-h6' : 'green--text'">{{mensaje_proceso}}</span><br>
              <span v-if="es_error" esclass="mt-10 text-h9">(Err: {{es_error}})<br/></span>
              
             <br/>
               <v-spacer></v-spacer>
              <span v-if="!es_error" class='text-h9 yellow--text font-weight-normal'>email: </span><span class='text-h6 white--text font-weight-normal'>{{email}}</span>
          </v-container>            

          <v-spacer></v-spacer>
          <div v-if="($global.deviceInfo.platform == 'web')" class="mt-5">
            <router-link to="/" replace>Iniciar sesión</router-link>
          </div>
          
        </div>
      </center>

    <div style="height: 40px"></div>
    </div>
    </div>
  </section>
</template>

<script>


export default {
  name: "RegistroVerificado",
  data: () => ({
    mensaje_proceso: '',
    email: '',
    es_error: false
  }),

  computed: { 
  }, 

  mounted() {
    this.es_error = this.$route.query.error;
    if (this.es_error) 
      this.mensaje_proceso = 'Ha ocurrido un error en la verificación del Usuario.';
    else
      this.mensaje_proceso = 'El registro de Usuario ha sido verificado correctamente.';
    this.email = this.$route.query.email;
  }
};
</script>

<style scoped> 

</style> 